import bytesToSize from '../../utils/bytesToSize';

export default function urlPluginMessage({ maxSize }) {
  const message = [
    `The maximum file size allowed is ${bytesToSize(maxSize)}.`,
    '<br />',
    'Importing a file from a link may fail if the link is protected.',
    'If the import fails, we recommend downloading the file to your computer and uploading from your computer.',
  ].join(' ');

  return document
    .createRange()
    .createContextualFragment(`<div class='uimutator-urlmessage'>${message}</div>`);
}
